import { Site } from "./site";
export class StructureManager {
    structureMap;
    savedStructureMap;
    constructor() {
        this.structureMap = new Map();
        this.savedStructureMap = new Map();
    }
    getStructure(id) {
        return this.structureMap.get(id);
    }
    addStructure(uniqueId, structure) {
        this.structureMap.set(uniqueId, structure);
        // get connections from saved structure and update the children
        const connectionNodes = this.savedStructureMap.get(uniqueId);
        if (connectionNodes && connectionNodes.length > 0) {
            // all connection node might not be loaded
            // add connection for only the loaded ones
            //loop backward to avoid reindexing
            for (let i = connectionNodes.length - 1; i >= 0; --i) {
                // if(this.structureMap.get(connectionNodes[i].to.id)){
                this.addConnection(connectionNodes[i]);
                //   connectionNodes.splice(i,1);
                // }
            }
            connectionNodes.length = 0;
            connectionNodes.length === 0 && this.savedStructureMap.delete(uniqueId);
        }
    }
    deleteStructure(uniqueId) {
        this.structureMap.delete(uniqueId);
    }
    addConnection(node) {
        if (node.from.id !== node.to.id) {
            const from = this.structureMap.get(node.from.id);
            from.connectionNodes.push(node);
        }
    }
    removeConnectionfromParent(childId) {
        this.structureMap.forEach((structure) => {
            const nodes = structure.connectionNodes.filter((n) => n.to.id !== childId);
            structure.connectionNodes.length = 0;
            structure.connectionNodes.push(...nodes);
        });
    }
    //
    reComputeConnectionNodesConnectedToChildStructure(id) {
        const site = Site.getInstance();
        const structure = this.structureMap.get(id);
        if (structure) {
            const connectionNodes = structure.getConnectionNodes();
            //remove connectionNode for specific Id
            this.removeConnectionfromParent(id);
            for (const node of connectionNodes) {
                this.addConnection(node);
            }
        }
    }
    reComputeChildrenGeometry(id) {
        const structure = this.structureMap.get(id);
        if (structure) {
            const childrenInOrder = this.getChildrenIdsInOrder(id);
            for (const id of childrenInOrder) {
                const childStructure = this.getStructure(id);
                if (childStructure) {
                    childStructure.updateGeometry();
                    childStructure.updateConnectionOnAddUpdatePoint();
                }
            }
        }
    }
    reComputeParentSiblingGeometry(id) {
        const structure = this.structureMap.get(id);
        if (structure) {
            const parentIds = this.getParentAndSiblingIdsInOrder(id);
            for (const id of parentIds) {
                const parentStructure = this.getStructure(id);
                if (parentStructure) {
                    parentStructure.updateGeometry();
                    parentStructure.updateConnectionOnAddUpdatePoint();
                }
            }
        }
    }
    clear() {
        this.structureMap.clear();
        this.savedStructureMap.clear();
    }
    getConnectionsJSON() {
        const json = {};
        this.structureMap.forEach((val, key) => {
            json[key] = [];
            for (const node of val.connectionNodes) {
                json[key].push({
                    id: node.id,
                    from: {
                        id: node.from.id,
                        proportionInTotal: node.from.proportionInTotal,
                    },
                    to: {
                        id: node.to.id,
                        controlPointIndex: node.to.controlPointIndex,
                    },
                });
            }
        });
        this.savedStructureMap.forEach((connectionNodes, key) => {
            json[key] = json[key] || [];
            for (const node of connectionNodes) {
                json[key].push({
                    id: node.id,
                    from: {
                        id: node.from.id,
                        proportionInTotal: node.from.proportionInTotal,
                    },
                    to: {
                        id: node.to.id,
                        controlPointIndex: node.to.controlPointIndex,
                    },
                });
            }
        });
        return json;
    }
    loadConnectionsJSON(jsonStr) {
        const json = JSON.parse(jsonStr);
        this.structureMap.clear();
        for (const key in json) {
            // const structure = new Structure();
            const connectionNodes = [];
            for (const info of json[key]) {
                connectionNodes.push({
                    id: info.id,
                    from: {
                        id: info.from.id,
                        proportionInTotal: info.from.proportionInTotal,
                    },
                    to: {
                        id: info.to.id,
                        controlPointIndex: info.to.controlPointIndex, // eitther 0 or last
                    },
                });
            }
            this.savedStructureMap.set(key, connectionNodes);
        }
    }
    getParentsIds(structureId) {
        const result = [];
        this.structureMap.forEach((structure, id) => {
            const nodes = structure.connectionNodes.filter((n) => n.to.id === structureId);
            nodes.length > 0 && result.push(id);
        });
        return result;
    }
    getParentsNodes(structureId) {
        const result = [];
        this.structureMap.forEach((structure) => {
            const nodes = structure.connectionNodes.filter((n) => n.to.id === structureId);
            nodes.length > 0 && result.push(...nodes);
        });
        return result;
    }
    getParentAndSiblingIdsInOrder(structureId) {
        //BFS
        const parentsInOrder = [];
        const siblingsInOrder = [];
        const visitedIds = new Set();
        const stack_fifo = [];
        stack_fifo.push(structureId);
        while (stack_fifo.length > 0) {
            const currentId = stack_fifo.shift();
            if (!visitedIds.has(currentId)) {
                visitedIds.add(currentId);
                //parent nodes
                const connectionNodes = this.getParentsNodes(currentId);
                for (const node of connectionNodes) {
                    if (!visitedIds.has(node.from.id)) {
                        const siblingIdsInOrder = this.getChildrenIdsInOrder(node.from.id, currentId);
                        stack_fifo.push(node.from.id);
                        parentsInOrder.push(node.from.id);
                        siblingsInOrder.push(...siblingIdsInOrder);
                    }
                }
            }
        }
        return [...parentsInOrder, ...siblingsInOrder];
    }
    getParentAndSiblingNodesInOrder(structureId) {
        //BFS
        const parentsInOrder = [];
        const siblingsInOrder = [];
        const visitedIds = new Set();
        const stack_fifo = [];
        stack_fifo.push(structureId);
        while (stack_fifo.length > 0) {
            const currentId = stack_fifo.shift();
            if (!visitedIds.has(currentId)) {
                visitedIds.add(currentId);
                //parent nodes
                const connectionNodes = this.getParentsNodes(currentId);
                for (const node of connectionNodes) {
                    if (!visitedIds.has(node.from.id)) {
                        const siblingNodesInOrder = this.getChildrenNodesInOrder(node.from.id, currentId);
                        stack_fifo.push(node.from.id);
                        parentsInOrder.push(node);
                        siblingsInOrder.push(...siblingNodesInOrder);
                    }
                }
            }
        }
        return [...parentsInOrder, ...siblingsInOrder];
    }
    getChildrenIdsInOrder(structureId, excludeChildId) {
        //BFS
        const childrenInOrder = [];
        const visitedIds = new Set();
        const stack_fifo = [];
        stack_fifo.push(structureId);
        while (stack_fifo.length > 0) {
            const currentId = stack_fifo.shift();
            if (!visitedIds.has(currentId)) {
                visitedIds.add(currentId);
                //neighbors
                const currentStructure = this.structureMap.get(currentId);
                if (currentStructure) {
                    for (const node of currentStructure.connectionNodes) {
                        if (!visitedIds.has(node.to.id) ||
                            (excludeChildId && node.to.id === excludeChildId)) {
                            stack_fifo.push(node.to.id);
                            childrenInOrder.push(node.to.id);
                        }
                    }
                }
            }
        }
        return childrenInOrder;
    }
    getChildrenNodesInOrder(structureId, excludeChildId) {
        //BFS
        const childrenInOrder = [];
        const visitedIds = new Set();
        const stack_fifo = [];
        stack_fifo.push(structureId);
        while (stack_fifo.length > 0) {
            const currentId = stack_fifo.shift();
            if (!visitedIds.has(currentId)) {
                visitedIds.add(currentId);
                //neighbors
                const currentStructure = this.structureMap.get(currentId);
                for (const node of currentStructure.connectionNodes) {
                    if (!visitedIds.has(node.to.id) ||
                        (excludeChildId && node.to.id === excludeChildId)) {
                        stack_fifo.push(node.to.id);
                        childrenInOrder.push(node);
                    }
                }
            }
        }
        return childrenInOrder;
    }
    getImmediateChildrenNodes(structureId) {
        const structure = this.structureMap.get(structureId);
        if (structure) {
            return structure.connectionNodes;
        }
        return [];
    }
}
//# sourceMappingURL=structure-manager.js.map